import React from "react";
import { MaterialDesignIcons } from "../styled";

interface DragIndicatorMIconProps {
  horizontal?: boolean;
}

export const DragIndicatorMIcon = ({ horizontal }: DragIndicatorMIconProps) => {
  return (
    <MaterialDesignIcons horizontal={horizontal?.toString()}>drag_indicator</MaterialDesignIcons>
  );
};
